// import React, { useState } from "react";
// import "./MainHeader.css";

// import krrlogo from "../assets/logo.jpg";
// import iworkkzlogo from "../assets/iWORKKZ.png";

// export default function MainHeader() {
//   const [active, setActive] = useState("Enquiry");

//   return (
//     <div className="headercontainer">
//       <div className="header-logocontainer">
//         <img src={krrlogo} alt="krrlogo" className="krrlogo" />
//         <img src={iworkkzlogo} alt="iworkkzlogo" className="iworkkzlogo" />
//       </div>
//       <div className="header-menubar">
//         <button
//           className={active === "Feedback" ? "active-btn" : ""}
//           onClick={() => setActive("Feedback")}
//         >
//           Feedback
//         </button>

//         <button
//           className={active === "Enquiry" ? "active-btn" : ""}
//           onClick={() => setActive("Enquiry")}
//         >
//           Enquiry
//         </button>

//         <button
//           className={active === "Admin" ? "active-btn" : ""}
//           onClick={() => setActive("Admin")}
//         >
//           Admin
//         </button>
//       </div>
//     </div>
//   );
// }

import React from "react";
import "./MainHeader.css";
import { useNavigate } from "react-router-dom";

import krrlogo from "../assets/logo.jpg";
import iworkkzlogo from "../assets/iWORKKZ.png";

export default function MainHeader({ active, setActive }) {
  const navigate = useNavigate();
  return (
    <div className="headercontainer">
      <div className="header-logocontainer">
        <img src={krrlogo} alt="krrlogo" className="krrlogo" />
        <img src={iworkkzlogo} alt="iworkkzlogo" className="iworkkzlogo" />
      </div>

      <div className="header-menubar">
        <button
          className={active === "Feedback" ? "active-btn" : ""}
          onClick={() => setActive("Feedback")}
        >
          Feedback
        </button>

        <button
          className={active === "Enquiry" ? "active-btn" : ""}
          onClick={() => setActive("Enquiry")}
        >
          Enquiry
        </button>

        <button
          className={active === "Admin" ? "active-btn" : ""}
          onClick={() => setActive("Admin")}
        >
          Admin
        </button>
      </div>
    </div>
  );
}
